import { lastDays } from '@/utils/dateRanges'
import type { Dayjs } from 'dayjs'

export const MAX_DASHBOARD_WINDOW_DAYS = 30

export interface DashboardWindow {
  start: string
  end: string
}

export { lastDays }

export function dashboardPresets(): { label: string; value: [Dayjs, Dayjs] }[] {
  return [
    { label: '1 day', value: lastDays(1) },
    { label: '3 days', value: lastDays(3) },
    { label: '7 days', value: lastDays(7) },
    { label: '14 days', value: lastDays(14) },
    { label: '30 days', value: lastDays(30) },
  ]
}

export function toDashboardWindow([start, end]: [
  Dayjs,
  Dayjs,
]): DashboardWindow {
  return { start: start.toISOString(), end: end.toISOString() }
}
